module.exports = "/_next/static/images/avatar_Jarda-962995c4a22e65d90ea7a47435a084ba.svg";